export default __webpack_public_path__ + "static/media/product-15 (1).d0a85669.jpg";